export default __webpack_public_path__ + "static/media/Application Box2Home3.e5ca18ed.svg";